import Label from '../../../../ui/label'
import { useDispatch, useSelector } from 'react-redux';
import { resetAmountOfLoans } from '../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice';
import { resetLevelRanking } from '../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice';
import { resetUniformCoverage } from '../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice';
import { resetSalaryRank } from '../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice';
import { resetSelectedRiders } from '../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice';
import LoadingCategory from '../../../../ui/loading-category';
import ErrorFetch from '../../../../ui/error-fetch-category';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { useMemo } from 'react';
import { resetCoverageType, setSelectedBasicPlansBox, setSelectedProductTypeBox, setSelectedProposalTypeBox } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice';
import { resetBorrowerAge, resetBorrowerAgeOptions } from '../../../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice';
import { resetLoanMaturityType, setSelectedPaymentTermBox } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import Checkbox from '../../../../ui/checkbox';
import { selectAmendmentModalOne } from '../../../../../features/actuarial/request-amendment/request-amendment.slice';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { useModalAccess } from '../../../../global/modal/use-modal-access';

export default function ClientInputTypeOfProposal() {

    const dispatch = useDispatch();
    const { 
        typeOfProposal, 
        isLoadingTypeOfProposal, 
        isErrorTypeOfProposal, 
        errorMessageTypeOfProposal 
    } = useQueries()
    const {
        proposalTypeState,
    } = useProposalTypeData()
    const { isPrototype } = useModalAccess();
    const isErrorLoading = isErrorTypeOfProposal || isLoadingTypeOfProposal
    const amendmentModalOne = useSelector(selectAmendmentModalOne)
    const isDisabled = amendmentModalOne === 'isRequesting'

    const handleChangeProductType = (e: React.ChangeEvent<HTMLInputElement>, option: SubTypeOption) => {
        dispatch(setSelectedProposalTypeBox(option));
        dispatch(setSelectedProductTypeBox(null));
        //GCLI
        dispatch(setSelectedBasicPlansBox(null));
        dispatch(resetAmountOfLoans());
        //GYRT
        dispatch(resetCoverageType());
        dispatch(resetLevelRanking());
        dispatch(resetUniformCoverage())
        dispatch(resetSalaryRank());
        //RESET TABLE INPUT
        dispatch(resetSelectedRiders());
        //RESET PAYMENT TERM
        dispatch(setSelectedPaymentTermBox(null));
        //RESET LOAN MATURITY
        dispatch(resetLoanMaturityType());
        //RESET BORROWER AGE
        dispatch(resetBorrowerAge())
        // RESET BENEFIT AMOUNT AND RATE
        dispatch(resetBorrowerAgeOptions())
    };

    const mappedOptions = useMemo(() => typeOfProposal?.map(({ id, name }) => ({ id, name, })) ?? [], [typeOfProposal]);

    return (
        <div className="space-y-3 rounded bg-white p-3.5 md:p-4 border border-gray-200">
            <div className="space-y-2">
                <Label
                    label="Type of Proposal"
                    fontWeight="font-semibold text-gray-800"
                    fontSize="text-xs"
                    requiredText=" *"
                    isRequired={true}
                />
                <div className={`grid ${isErrorLoading ? 'grid-cols-1' : 'grid-cols-1'} gap-2`}>
                    {isLoadingTypeOfProposal ? (
                        <LoadingCategory />
                    ) : isErrorTypeOfProposal ? (
                        <ErrorFetch errorMessage={errorMessageTypeOfProposal} />
                    ) : (
                        mappedOptions.map((option) => {
                            const isSelected: boolean = proposalTypeState?.id === option.id;
                            return (
                                <Checkbox
                                    key={option.id}
                                    disabled={isPrototype || isDisabled} 
                                    option={option} 
                                    isSelected={isSelected} 
                                    onChange={handleChangeProductType}
                                />
                            )
                        })
                    )}
                </div>
            </div>
            {/* { isPrototype && ( <ClientInputPrototype/> )}
            { isCustomize && ( <ClientInputProductTypes/> )} */}
        </div>
    )
}